<script setup lang="ts">
import { FormInput } from "@easy/ui/forms";
import { CardToggle } from "@easy/ui/cards";
import { PageSidebar } from "@easy/ui/page-components";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import BlockImage from "@/apps/page/project/sidebar/sections/block/BlockImage.vue";
import { useActions, useState } from "@/store/vuex-composition-mappers";
import CustomDomains from "@/apps/page/project/sidebar/settings/CustomDomains.vue";

// @ts-expect-error
const { page, hasChanges } = useState("page", ["page", "hasChanges"]);
// @ts-expect-error
const { saveSnapshot } = useActions("page/projects", ["saveSnapshot"]);
</script>

<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("page.menu.settings") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <FormInput
                    :title="$t('page.settings.page_title')"
                    :placeholder="$t('page.settings.page_title_placeholder')"
                    v-model="page.settings.title"
                />
                <FormInput
                    :title="$t('page.settings.page_description')"
                    :placeholder="$t('page.settings.page_description_placeholder')"
                    v-model="page.settings.description"
                />
                <BlockImage :title="$t('page.settings.image')" v-model="page.settings.image" />
                <BlockImage :title="$t('page.settings.favicon')" v-model="page.settings.favicon" />
                <BlockImage :title="$t('page.settings.webclip')" v-model="page.settings.webclip" />
            </div>
            <CardToggle :title="$t('page.settings.custom_domains.title')">
                <CustomDomains :pageUuid="page.uuid" />
            </CardToggle>
        </template>
        <template #sidebarFooter>
            <cSaveButton @save="saveSnapshot" :disabled="!hasChanges" />
        </template>
    </PageSidebar>
</template>
